import React, { PureComponent } from 'react';
import { Export } from '../../../common/export';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { getCurrentDate, isNotLoginOrExpired } from '../../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';

class ExportValuation extends PureComponent {
  getExportName = () => {
    return `${I18n.t('common.export.marketIndepth.valuation', {
      date: getCurrentDate(),
    })}.png`;
  };

  onClickLockedExport = () => {
    EventEmitter.dispatch(SHOW_GUEST_POPUP);
  };

  render() {
    const { user } = this.props;
    if (isNotLoginOrExpired(user)) {
      return (
        <div onClick={this.onClickLockedExport} className="locked-export">
          <Export
            exportId="valuation-chart"
            exportName={this.getExportName()}
          />
        </div>
      );
    }

    return (
      <Export exportId="valuation-chart" exportName={this.getExportName()} />
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  user: state.userInfo,
});

export default connect(mapStateToProps)(ExportValuation);
